<template>
  <div>
    <v-layout class="mt-2 mb-2">
      <v-flex xs6>
        <BuscaSimplesApi
          label="Buscar"
          :disabled="acao != ''"
          route="ei/atividadeavaliativa"
          :fieldSearch="buscarSelect"
          @found="encontrado"
          ref="buscaSimpleApi">
          <template slot-scope="propSlot">
            <span>{{ propSlot.item.descricaoatividadeavaliativa }}</span>
          </template>
        </BuscaSimplesApi>
      </v-flex>
      <v-flex xs4 class="ml-3">
        <Select :options="buscaOptions" v-model="buscarSelect" label="" @change="selectBuscaChange"/>
      </v-flex>
    </v-layout>

    <v-alert type="error" :value="($v.$invalid && $v.$dirty) || msgArrayError.length > 0" style="color: white;">
      <div v-if="$v.$invalid && $v.$dirty"> Preencha os campos corretamente.</div>
      <div v-if="msgArrayError.length > 0">
        <ul v-for="error of msgArrayError" :key="error.key">
          <li>{{ error }}</li>
        </ul>
      </div>
    </v-alert>

    <FormBasico
      :acao="acao"
      :id="form.identificadoratividade"
      :novo="novaAA"
      :editar="editarAA"
      :excluir="excluirAA"
      :cancelar="cancelarAA"
      :submit="onSubmit">
      <v-tabs>
        <v-tabs-slider color="#fff"></v-tabs-slider>
        <v-tab @click="tabela">
          <v-icon left color="#757575">view_list</v-icon>
        </v-tab>
      </v-tabs>
      <v-card>
        <v-card-text >
          <Input type="text" label="Código da Atividade Avaliativa" v-model="form.identificadoratividade" disabled />
          <Input type="text" label="Descrição da Atividade Avaliativa"  ref="focusCampo" v-model="form.descricaoatividadeavaliativa" :disabled="acao == '' || acao === 'editar'" :v="$v.form.descricaoatividadeavaliativa"/>
          <Input type="text" label="Sigla da Atividade Avaliativa" @input="upperCase" v-model="form.siglaatividadeavaliativa" :disabled="acao == '' || acao === 'editar'" :v="$v.form.siglaatividadeavaliativa"/>
          <Select label="Tipo de Atividade" :options="indicaatividadeOptions" v-model="form.indicaatividade"  :disabled="acao == '' " :v="$v.form.indicaatividade"/>
          <Select label="Avaliada de que forma?" :options="indicaformaavaliacaoOptions" v-model="form.indicaformaavaliacao" :disabled="acao == '' " :v="$v.form.indicaformaavaliacao"/>
          <Validator label="Pode detalhar o item?" :disabled="acao == ''" :v="$v.form.indicadetalhamento" >
            <Radio name="detalhar" v-model="form.indicadetalhamento" :disabled="acao == ''" val="N" label="Não"/>
            <Radio name="detalhar" v-model="form.indicadetalhamento" :disabled="acao == ''"  val="S" label="Sim"/>
          </Validator>
          <Validator label="Indica Uso?" :disabled="acao == ''" :v="$v.form.indicauso">
            <Radio name="indica" v-model="form.indicauso" :disabled="acao == ''" val="N" label="Não"/>
            <Radio name="indica" v-model="form.indicauso" :disabled="acao == ''"  val="S" label="Sim"/>
          </Validator>
          </v-card-text>
      </v-card>
    </FormBasico>

    <v-snackbar v-model="snackbar" bottom left :timeout="4000" height="10px" rounded="0"  >
        <div class="d-flex justify-space-between align-center">
           <span> {{ submitText }}</span>
            <v-btn class="text-right" variant="text"  icon  @click="snackbar = false" > <v-icon>close</v-icon> </v-btn>
        </div>
    </v-snackbar>
  </div>
</template>

<script>

import { RepositoryFactory } from '@/repositories/RepositoryFactory';
const AARepository = RepositoryFactory.get('atividadeAvaliativa');

import api from '@/api';
import BuscaSimplesApi from '@/components/BuscaSimplesApi';
import {
  required, maxLength, minLength, alpha, integer,
} from 'vuelidate/lib/validators';
import { alphaSpace } from '@/validations';

const setFormInicial = () => ({
  identificadoratividade: '',
  descricaoatividadeavaliativa: '',
  siglaatividadeavaliativa: '',
  indicaatividade: 'N',
  indicaformaavaliacao: 'QT',
  indicadetalhamento: 'N',
  indicauso: 'S'
});

export default {
  name: 'AtividadeAvaliativa',
  components: {
    BuscaSimplesApi,
  },
  data() {
    return {
      acao: '',
      form: setFormInicial(),
      submitText: '',
      snackbar: false,
      msgArrayError: [],
      buscarSelect: 'descricaoatividadeavaliativa',
      buscaOptions: [
        { value: 'identificadoratividade', text: 'Código' },
        { value: 'descricaoatividadeavaliativa', text: 'Descrição' },
        { value: 'siglaatividadeavaliativa', text: 'Sigla' },
      ],
      indicaatividadeOptions: [
        {value: 'N', text: 'Normal'},
        {value: 'E', text: 'Especial'},
        {value: 'R', text: 'Recuperação'},
        {value: 'P', text: 'Paralela'}
      ],
      indicaformaavaliacaoOptions:[
        {value:'QT', text:'Quantitativa'},
        {value:'QL', text:'Qualitativa'}
      ],
      formUltimo: {},
    };
  },
  validations() {
    return {
      form: {
        descricaoatividadeavaliativa: {
          required, maxLength: maxLength(400), minLength: minLength(4),
        },
        siglaatividadeavaliativa:{
          required: ((this.form.indicaformaavaliacao === 'QT')? required : ''), maxLength: maxLength(10), minLength: minLength(1),
        },
      },
    };
  },
  methods: {
    upperCase(value){
      this.form.siglaatividadeavaliativa = value.toUpperCase();
    },
    tabela() {
      this.$root.$router.push({
        name: 'tabelas',
        params: {
          titulo: 'Atividade Avaliativa / Listar',
          rota_api: 'ei/atividadeavaliativa/tabela',
          headers: [{ text: 'Identificador', value: 'identificadoratividade', sortable: false },
						        { text: 'Descrição', value: 'descricaoatividadeavaliativa', sortable: false }],
        },
      });
    },
    novaAA() {
      this.acao = 'novo';
      this.form = setFormInicial();
      this.$v.$reset();
      setTimeout(() => this.$refs.focusCampo.$refs.input.focus(), 200);
    },
    editarAA() {
      this.acao = 'editar';
    },
    cancelarAA() {
      if (this.acao == 'novo') {
        this.form = setFormInicial();
      } else {
        this.form = { ...this.formUltimo };
      }
      this.acao = '';
      this.msgArrayError = [];
      this.$v.$reset();
    },
    async excluirAA() {
      const confirmar = await this.$sgal({
        title: 'Tem certeza?',
        text: 'Deseja realmente excluir esta atividade avaliativa?',
        type: 'warning',
        buttons: [
          { text: 'Sim, excluir', color: 'red', response: true },
          { text: 'Não, cancelar', color: 'grey', response: false },
        ],
      });

      if (confirmar) {
        try {
          const { data } = await AARepository.deleteAtividadeAvaliativa({id: this.form.identificadoratividade});

          this.acao = '';
          this.submitText = data.message;
          this.snackbar = true;
          this.form = setFormInicial();
          this.msgArrayError = [];
        } catch (error) {
          const ntfExcluir = await this.$sgal({
            title: 'Não foi possível!',
            text: error.response.data.errorMessage[0],
            type: 'notification',
          });
        }
      }
    },

    async onSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      try{
        const funcao = (this.acao === 'novo') ? 'post' : 'put';

        const { data } = await AARepository[`${funcao}AtividadeAvaliativa`](this.form);

        this.submitText = data.message;
        this.snackbar = true;
        this.msgArrayError = [];
        this.form = { ...data.results };
        this.acao = '';
      }
      catch (error){
        if (error.response.data.status == 'ERROR_BUSINESS_RULE') { this.msgArrayError = error.response.data.errorMessage; }
        if (window.scrollY >= 250) { window.scrollTo({ top: 0, behavior: 'smooth' }); }
      }
      this.$v.$reset();
    },
    encontrado(dados) {
      this.form = setFormInicial();
      this.form = { ...dados };
      this.formUltimo = { ...dados };
    },
    selectBuscaChange() {
      this.$refs.buscaSimpleApi.busca = '';
    },
  },
};
</script>

<style>

</style>
